var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#37B16A;}\n\t.st1{fill:#BFECCB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,31.3H4.6c-2.1,0-3.8-1.7-3.8-3.9V11.6c0-0.4,0.3-0.8,0.8-0.8h29c0.4,0,0.8,0.3,0.8,0.8v15.8 C31.3,29.5,29.5,31.3,27.4,31.3z M2.3,12.3v15.1c0,1.3,1,2.4,2.3,2.4h22.9c1.3,0,2.3-1.1,2.3-2.4V12.3H2.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.5,8.7c0-1.7-1.4-3.1-3.1-3.1H15.3c-1.3,0-2.5-0.8-2.9-2.1l0,0c-0.4-1.2-1.6-2-2.9-2h-5 c-1.7,0-3.1,1.4-3.1,3.1v7h29V8.7H30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,12.3h-29c-0.4,0-0.8-0.3-0.8-0.8v-7c0-2.1,1.7-3.9,3.8-3.9h5c1.6,0,3.1,1,3.6,2.6 c0.3,0.9,1.2,1.6,2.2,1.6h12.1c2.1,0,3.8,1.7,3.8,3.9v2.8C31.3,12,30.9,12.3,30.5,12.3z M2.3,10.8h27.5V8.7c0-1.3-1-2.4-2.3-2.4 H15.3c-1.6,0-3.1-1-3.6-2.6c-0.3-0.9-1.2-1.6-2.2-1.6h-5c-1.3,0-2.3,1.1-2.3,2.4L2.3,10.8L2.3,10.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12.3,27.2 21.8,21 12.3,14.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,27.9c-0.1,0-0.2,0-0.4-0.1c-0.2-0.1-0.4-0.4-0.4-0.7V14.8c0-0.3,0.1-0.5,0.4-0.7c0.2-0.1,0.5-0.1,0.8,0 l9.6,6.2c0.2,0.1,0.3,0.4,0.3,0.6c0,0.3-0.1,0.5-0.3,0.6l-9.6,6.2C12.5,27.9,12.4,27.9,12.3,27.9z M13,16.2v9.6l7.5-4.8L13,16.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunProject);
export default __webpack_public_path__ + "static/media/run_project.a695ebf69d7ca3f0cd395c42f3c0f3a0.svg";
export { ForwardRef as ReactComponent };